export const SaleOrderDeliveryValidation = (formData) => {
    const errors = {};
    debugger;
    if (!formData.vc_DeliveryFullName || formData.vc_DeliveryFullName==="") {
        errors.vc_DeliveryFullName = 'This field is required';
    }
    if (!formData.vc_DeliveryAddress1 || formData.vc_DeliveryAddress1==="") {
        errors.vc_DeliveryAddress1 = 'This field is required';
    }
     
    return errors;
};
